import React from 'react'

const Front = () => {
  return (
    <div className="skills__content">
        <h3 className="skills__title">Frontend Skills</h3>

        <div className="skills__box">
           <div className="skills__group">
                <div className="skills__data">
                <i class='bx bx-badge-check'></i>

                <div>
                    <h3 className="skills__name">HTML</h3>
                    <span className="skills_level">Intermediário</span>
                </div>
                </div>

                <div className="skills__data">
                <i class='bx bx-badge-check'></i>

                <div>
                    <h3 className="skills__name">CSS</h3>
                    <span className="skills_level">Intermediário</span>
                </div>
                </div>

                <div className="skills__data">
                <i class='bx bx-badge-check'></i>

                <div>
                    <h3 className="skills__name">JavaScript</h3>
                    <span className="skills_level">Intermediário</span>
                </div>
                </div>

                <div className="skills__data">
                <i class='bx bx-badge-check'></i>

                <div>
                    <h3 className="skills__name">React</h3>
                    <span className="skills_level">Intermediário</span>
                </div>
                </div>
            </div> 
        </div>

    </div>
  )
}

export default Front